import { useMutation, useQueryClient } from 'react-query'

import { AppEvents, QUERY_KEYS } from 'src/constants'
import { whiteLabelPartnersService } from 'src/services/white-label-partners.service'

export const useRemoveWhiteLabelPartners = () => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => whiteLabelPartnersService.removeWhiteLabelPartners(ids), {
    onSuccess: async (data) => {
      if (data) {
        queryClient.invalidateQueries(QUERY_KEYS.WHITE_LABEL_PARTNERS)
      }
    },
  })
}
